import React from 'react'

function FromPropByStaticName() {
    return (
        <span className='cs-exp-read-prop-static-name'>By static name</span>
    )
}

export { FromPropByStaticName }